
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'NewsItem',

  components: {
    WpImage,
  },

  filters: {
    sliced: (v) =>
      v ? (v.length > 70 ? `${v.slice(0, 70)}...` : v.slice(0, 70)) : null,
  },

  props: {
    post: {
      type: Object,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
  },
};
